import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Router} from "@angular/router";
import {AbstractRESTService} from "./rest/abstract.rest.service";

@Injectable()
export class GetConfigService {
	config: any;
	rest: AbstractRESTService;
	private subscribers: (() => void)[] = [];

    constructor(http: HttpClient, router: Router) {
		this.rest = new AbstractRESTService(http, environment.casBaseUrl, router);
		this.getConfig();
    }

	getConfig(): void {
		this.rest.get('configuration/settings').subscribe((response) => {
			this.config = response;
			this.notifySubscribers();
		}, err => {
			this.config = null;
			console.log('could not retrieve system details');
			this.notifySubscribers();
		})
	}

	subscribeForConfigChange(subscriber: () => void) {
		this.subscribers.push(subscriber);
	}

	unsubscribe(subscriber: () => void) {
		this.subscribers = this.subscribers.filter((sub) => {
			return sub !== subscriber;
		});
	}

	notifySubscribers() {
        this.subscribers.forEach(it => it());
    }
}
